import { Link } from "react-router-dom";
import { 
  Car, 
  Phone, 
  Mail, 
  MapPin, 
  MessageCircle, 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin,
  ArrowRight,
  Shield,
  Clock
} from "lucide-react";
import { Button } from "@/components/ui/button";

export const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-blue-900 to-gray-800 text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-green-500 rounded-xl flex items-center justify-center shadow-lg">
                <Car className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-bold text-2xl bg-gradient-to-r from-blue-400 to-green-400 bg-clip-text text-transparent">
                  Timelyyy
                </h3>
                <p className="text-sm text-gray-400">Vehicle Wash Booking</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6 text-sm sm:text-base">
              India's leading vehicle wash booking platform connecting customers with premium wash centers. 
              Book, pay, and track your vehicle wash through WhatsApp integration.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <Button size="icon" variant="ghost" className="text-gray-400 hover:text-white hover:bg-blue-600/20 h-9 w-9 sm:h-10 sm:w-10">
                <Facebook className="w-4 h-4 sm:w-5 sm:h-5" />
              </Button>
              <Button size="icon" variant="ghost" className="text-gray-400 hover:text-white hover:bg-blue-600/20 h-9 w-9 sm:h-10 sm:w-10">
                <Twitter className="w-4 h-4 sm:w-5 sm:h-5" />
              </Button>
              <Button size="icon" variant="ghost" className="text-gray-400 hover:text-white hover:bg-blue-600/20 h-9 w-9 sm:h-10 sm:w-10">
                <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
              </Button>
              <Button size="icon" variant="ghost" className="text-gray-400 hover:text-white hover:bg-blue-600/20 h-9 w-9 sm:h-10 sm:w-10">
                <Linkedin className="w-4 h-4 sm:w-5 sm:h-5" />
              </Button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center group">
                  <ArrowRight className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center group">
                  <ArrowRight className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform" />
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center group">
                  <ArrowRight className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform" />
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/onboard-vendor" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center group">
                  <ArrowRight className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform" />
                  Join as Vendor
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-300 flex items-center">
                <Car className="w-4 h-4 mr-2 text-blue-400" />
                Car Wash Booking
              </li>
              <li className="text-gray-300 flex items-center">
                <MessageCircle className="w-4 h-4 mr-2 text-green-400" />
                WhatsApp Integration
              </li>
              <li className="text-gray-300 flex items-center">
                <Shield className="w-4 h-4 mr-2 text-blue-400" />
                Secure Payments
              </li>
              <li className="text-gray-300 flex items-center">
                <Clock className="w-4 h-4 mr-2 text-green-400" />
                Real-time Updates
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6 text-white">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">+91 7058289819</p>
                  <p className="text-sm text-gray-400">24/7 Support</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-green-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">support@timelyyy.com</p>
                  <p className="text-sm text-gray-400">Email Support</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">Surat, Gujarat</p>
                  <p className="text-sm text-gray-400">India</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MessageCircle className="w-5 h-5 text-green-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">WhatsApp Business</p>
                  <p className="text-sm text-gray-400">Instant Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-5 sm:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              © {new Date().getFullYear()} Timelyyy. All rights reserved. Made by @lastmindevs
            </div>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/tnc" className="text-gray-400 hover:text-white transition-colors">
                Terms & Conditions
              </Link>
              <Link to="/refund" className="text-gray-400 hover:text-white transition-colors">
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
